<template>
  <div class="card has-padding-20 has-padding-left-0">
    <div class="card-content">
      <div class="field has-margin-top-10 has-margin-bottom-10 is-pulled-right">
        <div class="control">
          <button
            class="button is-primary"
            @click="UpdateShippingRequest(data.id)"
          >
            <a class="has-text-white">Update State</a>
          </button>
        </div>
      </div>
      <br />
      <br />
      <br />
      <MainDGDetail :data="data"> </MainDGDetail>
      <update-modal v-if="updateStatus"></update-modal>
    </div>
  </div>
</template>

<script>
import MainDGDetail from "./MainDGDetails";
import UpdateModal from "./UpdateModal";

export default {
  name: "MainShippingDetail",
  components: { MainDGDetail, UpdateModal },
  props: {
    data: Object
  },
  data() {
    return {
      updateStatus: false
    };
  },

  computed: {
    dangerousGoods: function() {
      return this.data.dangerousGoods;
    }
  },
  methods: {
    UpdateShippingRequest: function(id) {
      this.$modal.open({
        parent: this,
        component: UpdateModal,
        hasModalCard: true,
        props: {
          id: id
        }
      });
    }
  }
};
</script>
<style scoped>
.single_dg {
  background-color: red;
  margin-top: 40px;
  margin-bottom: 40px;
  border-bottom: 2px dotted #ccc;
}
</style>
